import {Children, FC, PropsWithChildren, ReactElement, cloneElement} from 'react';

import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';
import {Box, Button, Divider, Modal, Stack, Toolbar, Typography} from '@mui/material';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  width: 500,
  p: 2,
};

interface IConfirmAction {
  loading: boolean;
  open: boolean;
  handleSideEffect: () => any;
  handleClose: () => void;
  title: string;
  buttonTitle: string;
  isReady?: boolean;
}

export const ConfirmAction: FC<PropsWithChildren<IConfirmAction>> = ({
  loading,
  open,
  handleClose,
  handleSideEffect,
  title,
  buttonTitle,
  isReady = true,
  children,
}) => {
  return (
    <Modal open={open}>
      <Box sx={style}>
        <Toolbar
          sx={{
            pl: {sm: 1},
            pr: {xs: 1, sm: 1},
          }}
        >
          <Typography sx={{flex: '1 1 100%'}} variant="h6" id="formTitle" component="div">
            {title}
          </Typography>
        </Toolbar>
        {children}
        <Divider sx={{m: '10px 0'}} />
        <Stack direction="row" sx={{justifyContent: 'space-between'}}>
          <Button variant="outlined" color="error" disabled={loading} onClick={handleClose}>
            Отменить
          </Button>
          <LoadingButton disabled={!isReady} variant="contained" onClick={handleSideEffect} loading={loading}>
            {buttonTitle}
          </LoadingButton>
        </Stack>
      </Box>
    </Modal>
  );
};
